module.exports = __webpack_public_path__ + "static/media/comites-investigacion-mini.c2dcfcae.png";